import type { ReactNode } from 'react';
import { AlignLeft, Hash, Image, List, ToggleLeft, Type } from 'lucide-react';
import type { PropType } from '../constants';

/** Prop tipi → palet/liste ikonu (Forms fieldMeta deseni). */
export const PROP_ICONS: Record<PropType, ReactNode> = {
  text: <Type size={15} />,
  textarea: <AlignLeft size={15} />,
  number: <Hash size={15} />,
  boolean: <ToggleLeft size={15} />,
  select: <List size={15} />,
  'image-url': <Image size={15} />,
};
